import { ReactElement } from 'react';

import { DocplannerServiceMapping } from '@dreryk/egabinet-docplanner-frontend-api';

import { Heading, StyledFlex, Table } from '@dreryk/react-components';

import { medicalServicesMappingsTranslationKeys } from '../../translations';

import { AddNewMappingModalOpener } from './AddNewMappingModalOpener';
import { MedicalServicesMappingsEmptyStatePlaceholder } from './MedicalServicesMappingsEmptyStatePlaceholder';
import {
   useMedicalServicesLazyLoadedDataConfiguration,
   useMedicalServicesMappingsTableColumnConfiguration,
} from './MedicalServicesMappingsTable.hooks';

export const MedicalServicesMappingsTable = (): ReactElement => {
   const dataConfiguration = useMedicalServicesLazyLoadedDataConfiguration();

   return (
      <StyledFlex direction={'column'}>
         <Heading
            testId={'medicalServicesMappings'}
            type={'h2'}
            content={medicalServicesMappingsTranslationKeys.services}
         />
         <Table<DocplannerServiceMapping>
            testId={'medicalServicesMappings'}
            keyExtractor={'id'}
            columns={useMedicalServicesMappingsTableColumnConfiguration({
               onMappingRemoveSuccess: dataConfiguration.refetch,
            })}
            dataConfiguration={dataConfiguration}
            bottomElement={
               <AddNewMappingModalOpener
                  label={medicalServicesMappingsTranslationKeys.addMapping}
                  onMappingCreateSuccess={dataConfiguration.refetch}
                  alreadySelectedServicesIds={dataConfiguration.dataPart?.data.map(
                     (service) => service.docplannerService.id
                  )}
                  withLeadingIcon
               />
            }
            placeholder={
               <MedicalServicesMappingsEmptyStatePlaceholder onMappingCreateSuccess={dataConfiguration.refetch} />
            }
            compact
         />
      </StyledFlex>
   );
};
